import React, { useState } from 'react';
import { Input } from '../../ui/input';
import { Button } from '../../ui/button';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../ui/select';
import { Search, X } from 'lucide-react';

export function QueueFilters({ status, reason, tier, categoryId, ageHours, search, onFilterChange }) {
  const [localSearch, setLocalSearch] = useState(search);

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    onFilterChange({ status, reason, tier, categoryId, ageHours, search: localSearch });
  };

  const handleClearFilters = () => {
    setLocalSearch('');
    onFilterChange({ status: 'open,needs_moderation', reason: '', tier: '', categoryId: '', ageHours: '', search: '' });
  };

  const activeFilterCount = [status && status !== 'open,needs_moderation', reason, tier, categoryId, ageHours, search].filter(Boolean).length;

  return (
    <div className="space-y-4 mb-6">
      <form onSubmit={handleSearchSubmit} className="flex gap-2">
        <div className="relative flex-1">
          <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-400" />
          <Input
            type="text"
            placeholder="Search order ID, buyer, or seller email..."
            value={localSearch}
            onChange={(e) => setLocalSearch(e.target.value)}
            className="pl-10"
          />
        </div>
        <Button type="submit" variant="outline">Search</Button>
      </form>

      <div className="flex flex-wrap gap-3">
        <Select
          value={status}
          onValueChange={(val) => onFilterChange({ status: val, reason, tier, categoryId, ageHours, search })}
        >
          <SelectTrigger className="w-48">
            <SelectValue placeholder="Status" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="open,needs_moderation">Open + Needs Moderation</SelectItem>
            <SelectItem value="open">Open</SelectItem>
            <SelectItem value="negotiating">Negotiating</SelectItem>
            <SelectItem value="needs_moderation">Needs Moderation</SelectItem>
            <SelectItem value="escalated">Escalated</SelectItem>
            <SelectItem value="resolved">Resolved</SelectItem>
          </SelectContent>
        </Select>

        <Select
          value={reason || 'all'}
          onValueChange={(val) => onFilterChange({ status, reason: val === 'all' ? '' : val, tier, categoryId, ageHours, search })}
        >
          <SelectTrigger className="w-48">
            <SelectValue placeholder="Reason" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">All Reasons</SelectItem>
            <SelectItem value="scope">Scope Mismatch</SelectItem>
            <SelectItem value="late_delivery">Late Delivery</SelectItem>
            <SelectItem value="quality">Quality Issues</SelectItem>
            <SelectItem value="other">Other</SelectItem>
          </SelectContent>
        </Select>

        <Select
          value={tier || 'all'}
          onValueChange={(val) => onFilterChange({ status, reason, tier: val === 'all' ? '' : val, categoryId, ageHours, search })}
        >
          <SelectTrigger className="w-32">
            <SelectValue placeholder="Tier" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">All Tiers</SelectItem>
            <SelectItem value="0">T0</SelectItem>
            <SelectItem value="1">T1</SelectItem>
            <SelectItem value="2">T2</SelectItem>
            <SelectItem value="3">T3</SelectItem>
          </SelectContent>
        </Select>

        <Select
          value={ageHours || 'all'}
          onValueChange={(val) => onFilterChange({ status, reason, tier, categoryId, ageHours: val === 'all' ? '' : val, search })}
        >
          <SelectTrigger className="w-32">
            <SelectValue placeholder="Age" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">All Ages</SelectItem>
            <SelectItem value="24">≤24h</SelectItem>
            <SelectItem value="72">≤72h</SelectItem>
            <SelectItem value="168">≤7d</SelectItem>
          </SelectContent>
        </Select>

        {activeFilterCount > 0 && (
          <Button variant="ghost" size="sm" onClick={handleClearFilters} className="gap-1">
            <X className="h-4 w-4" />
            Clear ({activeFilterCount})
          </Button>
        )}
      </div>
    </div>
  );
}
